export function getOpeningTime(poiResult) {
    if(poiResult.type === 'PASSROAD') return false // fix for favourite POI
    const openingInformation = poiResult.computed && poiResult.computed.openingInformation ? poiResult.computed.openingInformation : poiResult.openingInformation;
    if(!openingInformation) return false;

    if(openingInformation.openAllDay) {
        return {
            color: 'green',
            label: '24 h geöffnet',
        };
    }

    if(openingInformation.minutesLeftOpen) {
        if(openingInformation.minutesLeftOpen < 60) {
            return {
                color: 'orange',
                label: `schließt in ${openingInformation.minutesLeftOpen} Min.`,
            };
        } else {
            return {
                color: 'green',
                label: `geöffnet`,
            };
        }
    }

    if(openingInformation.minutesLeftClosed) {
        if(openingInformation.minutesLeftClosed < 60) {
            return {
                color: 'orange',
                label: `öffnet in ${openingInformation.minutesLeftClosed} Min.`,
            };
        } else {
            return {
                color: 'red',
                label: `geschlossen`,
            };
        }
    }

    return false;
}

export function getOpeningTimeForSeason(poiResult) {
    if(poiResult.data?.openings) {
        let openingTime = false;
        for(const opening of poiResult.data.openings) {
            if(opening?.season?.from && opening?.season?.to) {
                const fromDate = getDateFromDayMonthString(opening.season.from);
                const toDate = getDateFromDayMonthString(opening.season.to);
                const today = new Date()
                if(isBetweenDates(today, fromDate, toDate)) {
                    openingTime = {
                        color: 'green',
                        label: `geöffnet`,
                    }
                } else {
                    openingTime = {
                        color: 'red',
                        label: `geschlossen`,
                    }
                }
            }
        }
        return openingTime
    }
    return false
}

function getDateFromDayMonthString(dateString) {
    const dateStringSplit = dateString.split('.');
    const date = new Date()
    date.setDate(parseInt(dateStringSplit[0]));
    date.setMonth(parseInt(dateStringSplit[1]) - 1);
    return date
}

function isBetweenDates(date, startDate, endDate) {
    return date >= startDate && date <= endDate;
}